<div
  class="dropdown relative"
  [class.dropdown--error]="hasError"
  [class.dropdown--disabled]="disabled"
  [class.dropdown--open]="isOpen"
  data-test="dropdown"
>
  <app-form-dropdown-trigger
    [triggerId]="id"
    tabindex="-1"
    [disabled]="disabled"
    [hasError]="hasError"
    [tabindex]="tabindex"
    [isOpen]="isOpen"
    [label]="triggerLabel"
    (click)="toggleMenu()"
    (keydown.enter)="toggleMenu()"
    (keydown.space)="toggleMenu()"
    (keydown.esc)="hideMenu()"
    (keydown.arrowup)="navigate($event, directionEnum.Up)"
    (keydown.arrowdown)="navigate($event, directionEnum.Down)"
    (keydown.home)="navigate($event, directionEnum.First)"
    (keydown.end)="navigate($event, directionEnum.Last)"
  ></app-form-dropdown-trigger>

  <app-form-dropdown-list
    [triggerId]="id"
    [isOpen]="isOpen"
    [options]="options"
    (selectOption)="setOption($event)"
  >
  </app-form-dropdown-list>
</div>
